import React, { Component } from 'react';

import linkedinLogo from '../assets/images/footer/linkedin.jpg';
import githubLogo from '../assets/images/footer/github.png';

export default class Footer extends Component {
  render() {
		
    return(
        <section className="footer" style={{ background: this.props.color }}>
          <div className="container">
            <div className="row">
              <div className="col s12">
                
                <div className="row footerRow">
                  <div className="footer-links">
                    <a className="" target="_blank" rel="noopener noreferrer" href="https://github.com/nicholaspsmith?tab=repositories"><img id="github-logo" src={githubLogo} alt="Github" /><br/>Github</a>
                  </div>
                <div className="footer-links">
                    <a className="" target="_blank" rel="noopener noreferrer" href="https://s3-us-west-2.amazonaws.com/nicholaspsmith/Nicholas_Smith_Resume.pdf"><i className="medium material-icons" id="resume-logo">description</i><br/>Resume</a>
                </div>
                <div className="footer-links">
                    <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/nps90/"><img id="linkedin-logo" src={linkedinLogo} alt="LinkedIn" /><br/>LinkedIn</a>
                </div>

                </div>

              </div>
            </div>
          </div>
          <div className="footer-copyright">
            <div className="container">
              ©2019 Nicholas P Smith
            </div>
          </div>
        </section>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/footer.js